import { Component, Input, OnInit, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

import { ConfirmationInput } from '@/shared/components/confirmation/confirmation.model';
import { WhichTVBoxComponent } from '../../components/which-tv-box/which-tv-box.component';

import { StrapiGenericComponentService, StrapiParserService, OutagesService } from '@/shared/services';
import { ActivatedRoute } from '@angular/router';
import { DiagnosticCheckService } from '@/shared/feature/diagnostic-check/services/diagnostic-check.service';
import { BaseComponent } from '@/shared/components/base/base.component';
import {
  ComponentElementsGenericComponent,
  ComponentElementsGlobalComponent,
} from '@/shared/interfaces/fault-article.interface';
import { AtomicArticleService } from '@/shared/feature/diagnostics-flow/services/atomic-article.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'vm-which-tv-box-shell',
  templateUrl: './which-tv-box-shell.component.html',
  styleUrls: ['./which-tv-box-shell.component.scss'],
  standalone: true,
  imports: [WhichTVBoxComponent, CommonModule],
})
export class WhichTVBoxShellComponent extends BaseComponent implements OnInit {
  strapiGenericComponentService = inject(StrapiGenericComponentService);
  strapiParserService = inject(StrapiParserService);
  strapiService = inject(AtomicArticleService);
  outagesService = inject(OutagesService);
  diagnosticService = inject(DiagnosticCheckService);
  oauthService = inject(OAuthService);
  route = inject(ActivatedRoute);

  @Input() content: ConfirmationInput;

  session = this.sessionService.getData();
  strapiUID = this.route.snapshot.data?.['strapiUID'];
  actionCode = this.route.snapshot.paramMap.get('actionCode')?.toLocaleUpperCase() || '';
  workflowName = this.route.snapshot.paramMap.get('workflowName')?.toLocaleLowerCase() || '';
  isLoaded = false;

  ngOnInit() {
    this.getTVBoxes();
  }

  getTVBoxes() {
    if (this.session?.id) {
      this.diagnosticService.getAccountCheck().subscribe(() => {
        this.diagnosticService.setDiagnosticFlow(this.actionCode);
        this.getContent();
      });
    } else {
      this.getContent();
    }
  }

  getContent() {
    const tvBoxes = this.session?.df?.tvBoxTypes || ['360', 'stream', 'v6', 'tivo'];
    if (tvBoxes && tvBoxes.length === 1) {
      return this.toUrl(`/status/guide/tv-sound-issues/${this.session?.df?.urlTVBoxType}select`);
    }

    this.strapiService.getArticles(this.strapiUID).subscribe((res) => {
      const tvBoxContent = (res[0].elements[0] as ComponentElementsGlobalComponent).genericComponent.filter(
        (generic: ComponentElementsGenericComponent) =>
          !generic?.uid || tvBoxes.includes(generic?.uid?.toLocaleLowerCase())
      );
      (res[0].elements[0] as ComponentElementsGlobalComponent).genericComponent = tvBoxContent;
      const art = this.strapiParserService.bindData(res[0], this.session);
      this.content = this.strapiGenericComponentService.formatArticleContent(art);
      this.isLoaded = true;
    });
  }
}
